import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";
import { Loader2 } from "lucide-react";

/**
 * Nested under ProtectedRoute. Users with `super_admin`, `support`, or `ops` in `public.admin_roles` may access admin UI.
 */
export function AdminRoute() {
  const { isLoading, user, adminRoleReady, canAccessAdmin } = useAuth();

  if (isLoading || (user && !adminRoleReady)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="w-8 h-8 animate-spin text-primary" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!canAccessAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}